import { getStoreCode } from './src/Store/Store.APP_ENV.js'; // webpack will replace this according to NODE_ENV
import { getTaopixUrl } from './src/Common/Helper';
import { getAPILocale } from './src/Locale/Locale.js';

const base = {
  api: "https://api.dev2.photobookco.com/api/v1",
  apiV2: "https://api.dev2.photobookco.com/api/v2",
  shipping: "https://shipping.api.dev2.photobookco.com/api/v1",
  shippingV2: "https://shipping.api.dev2.photobookco.com/api/v2",
  nodeApi : `${window.location.protocol}//${window.location.host}/api`,
  forwarder: "forward",
};

const code = getStoreCode();
const lang = getAPILocale(code);
const apiBaseUrl = `${base.api}/${ code }`;
const countryCode = code.substring(2);
const apiBaseUrlWithLang = `${base.api}/${code}/${lang}`;
const apiV2BaseUrlWithLang = `${base.apiV2}/${code}/${lang}`;
const apiShippingWithLang = `${base.shipping}/${lang}`;
const apiShippingViaBe = `${base.api}/${base.forwarder}/shipping/:path-name:`;
const apiShippingWithLangViaBE = `${apiShippingViaBe}/${lang}`;


function getCurrentCountryCode(sCode) {
  switch (sCode) {
    case 'WW':
      return 'MX';
    case 'EU':
      return 'DE';
    case 'UK':
      return 'GB';
    default:
      return sCode;
  }
}

export const currentCountryCode = getCurrentCountryCode(countryCode);

const storesWithoutBulkOrder = [];

function disableBulkOrder(sCode) {
  return storesWithoutBulkOrder.includes(sCode);
}

const config = {
  nodeApi: base.nodeApi,
  lang: lang,
  api: apiBaseUrl,
  apiBase: base.api,
  typingDelay: 500,
  shipping: base.shipping,
  shippingV2: base.shippingV2,
  storeCode: code,
  localeApi: apiBaseUrlWithLang,
  localeApiV2 : apiV2BaseUrlWithLang,
  localeShippingApi: apiShippingWithLang,
  s3BucketUrl: "https://media-staging.pbwwcdn.net",
  pbxEditor: "https://js-cdn.getprintbox.com/init/staging_pbww/init.min.js",
  pbxBackendUri: "https://pbww-pbx2-stag.getprintbox.com",
  pbxApi: `${apiBaseUrl}/printbox`,
  poolPbxApi: `${apiBaseUrl}/pbx-pool`,
  poolPbxLocaleApi: `${apiBaseUrlWithLang}/pbx-pool`,
  taopixStoreUrl: getTaopixUrl(window.location.hostname),
  recaptchaKey: "6Lds2U4UAAAAAAtBh2AIsEwJMMiPie_B73ZiIP_q",
  googleMapKey: 'AIzaSyChoveBMoLibGORIaDpqrH5FkuQGReicjE',
  releaseVersion: 'mobile_staging-41',
  offlineEditorVersion: "09-JUL-2024",
  offlineEditorServerUS: 'https://a-sl01.photobookworldwide.com',
  offlineEditorServerSG: 'https://a-sl02.photobookworldwide.com',
  faqUrl: 'https://photobookworldwide.kb.botplatform.io',
  googleTagManagerId: "GTM-K9T97T2",
  adyenHppUrl: "https://test.adyen.com/hpp/select.shtml",
  ipay88RequestUrl: 'https://payment.ipay88.com.my/epayment/entry.asp',
  m2uRequestUrl: "https://m2upayuat.maybank2u.com.my/testM2uPayment",
  adyenHppSkipDetailsUrl: "https://test.adyen.com/hpp/skipDetails.shtml",
  stripePublishableKey: "pk_test_veiZgKXaez1m9rbsbcXm6DvE00sWiLadv6",
  bulkOrderPath: "/bulk-order",
  bulkOrderDisabled: disableBulkOrder(code),
  voucherWalletOneLink: 'https://photobook.onelink.me/QDvH/voucherwallet',
  shippingViaBe: apiShippingViaBe,
  localeShippingApiViaBe: apiShippingWithLangViaBE,
  adyenClientKey: "test_Q5XNHNOUYRAPDHQ63SV2HCDTIEFFFFHS",
  trackerUrl: "https://trackbook-dev.system-074.workers.dev",
  pbLiveUrl: "https://beta.photobook.live",
  trackingUrl: "https://staging.tracking.photobookco.com",
  paypalClientId: "AWIrwZ54HC4Vy__wWoJyMUo9opOf8s8q1_BpKC_HODjYdUgKuOIL028KQ2zTNf9OL-CMYCCYBRy0NMTQ"
};

export default config;




// WEBPACK FOOTER //
// ./config.js